import React, { useCallback, useEffect, useState } from 'react';

import * as msgStorage from '../lib/storage/message';

type Message = msgStorage.Message;

type MsgContextProps = {
  // Message defines the user's message
  msg: Message | null;
  // setMsg sets a new message in context and stores it in local storage
  setMsg: (msg: Message) => void;
  // removeMsg removes the message from context and local storage
  removeMsg: () => void;
};

const MsgContext = React.createContext<MsgContextProps | null>(null);

/**
 * MsgContextProvider provides the msg context to it's children
 */
export function MsgContextProvider({ children }: React.PropsWithChildren<{}>) {
  const [msg, setMsgState] = useState(msgStorage.get());

  // Persist the token to local storage when the token changes. Remove the token
  // if it is null.
  useEffect(() => {
    if (msg) {
      msgStorage.set(msg);
    } else {
      msgStorage.remove();
    }
  }, [msg]);

  const removeMsg = useCallback(() => {
    setMsgState(null);
  }, []);

  const setMsg = useCallback((s) => {
    setMsgState(s);
  }, []);

  const ctx = {
    msg,
    setMsg,
    removeMsg,
  };

  return <MsgContext.Provider value={ctx}>{children}</MsgContext.Provider>;
}

export default MsgContext;
